import {useState,useEffect} from 'react'
import {useSelector,useDispatch} from 'react-redux'
import {useClients} from '../../users/hooks'

import {updateProgramAssign} from '../Packages/packagesSlice'

import useApiStatusEnvAwarePost from '../../../hooks/useApiStatusEnvAwarePost'

import {getActiveSubscriptions} from '../Subscriptions/activeSubscriptionsSlice'

import {
	usePackages,
	useMerchandiseItems,
	useAvailableSubscriptions
} from '../hooks'

import {envAwarePost,nMap} from '../../../util/util'

import useCurrencySettings from '../../../hooks/useCurrencySettings'

import Spinner from 'react-bootstrap/Spinner'
import Button from 'react-bootstrap/Button'
import Form from 'react-bootstrap/Form'

import Select from 'react-select'

import LocaleCurrency from '../../LocaleCurrency/LocaleCurrency'

import {Link} from 'react-router-dom'

import {
	setMultiFormsModal
} from '../../../state/customFormsSlice'

const Packages = ({status,packages,value,onSelect})=>{
	return (
		<div>
			<strong>Select a package</strong>
			<Form.Control value={value} onChange={e=>{
				onSelect(e.target.value)
			}} as="select" custom>
				<option value={0}>Choose Package</option>
				{packages.map(pkg=>(
					<option key={pkg.package_id} value={pkg.package_id}>
						{pkg.package_name}
					</option>
				))}
			</Form.Control>
		</div>
	)
}

const Subscriptions = ({status,value,subscriptions,onSelect,cycleAnchor,setCycleAnchor,prorationBehavior,setProrationBehavior})=>{
	

	return (
		<div>
			<strong>Select a Subscription</strong>
			<Form.Control value={value} onChange={e=>{
				onSelect(e.target.value)
			}} as="select" custom>
				<option value={0}>Choose Subscription</option>
				{subscriptions.map(sub=>(
					<option key={sub.subscription_id} value={sub.subscription_id}>
						{sub.name}
					</option>
				))}
			</Form.Control>
			<strong className="d-block">When to start subscription charges</strong>
			<small>
				<i className="fa fa-info-circle mr-1"/>
				For example, selecting 1 will cause the first payment to be charged on the 1st of the following month. Selecting Immediately will cause the subscription to start today. 
			</small>
			<Form.Control 
				as="select" 
				value={cycleAnchor}
				onChange={e=>{
					setCycleAnchor(parseInt(e.target.value))
				}}
			>
				<option value={0}>
					Immediately
				</option>
				{nMap(
					28,
					i=> <option value={i+1} key={i}>{i+1}</option>
				)}
			</Form.Control>
			{cycleAnchor>0&&
				<>
					<strong className="d-block">Charge a prorated amount now?</strong>
					<small>
						<i className="fa fa-info-circle mr-1"/>
						The first payment will not occur till next month but you can charge a prorated amount for the remainder of this month right now. 
					</small>
					<Form.Check
						checked={prorationBehavior==='create_prorations'}
						onChange={e=>{
							setProrationBehavior(
								e.target.checked
								? 'create_prorations'
								: 'none'
							)
						}}
						id="subscription-prorate-check"
						label="Charge prorated amount"
					/>
				</>
			}
		</div>
	)
}

const Merchandise = ({status,value,merchandise,onSelect})=>{
	return (
		<div>
			<strong>Select a Product</strong>
			<Form.Control value={value} onChange={e=>{
				onSelect(e.target.value)
			}} as="select" custom>
				<option value={0}>Choose Product</option>
				{merchandise.map(product=>(
					<option key={product.id} value={product.id}>
						{product.title}
					</option>
				))}
			</Form.Control>
		</div>
	)
}

const CustomPayment = ({value,onChange})=>{
	return (
		<div>
			<strong>Payment Amount</strong>
			<Form.Control
				onChange={e=>{onChange(e.target.value)}}
				placeholder="Amount"
				value={value}
			/>
		</div>
	)
}

export default function Charge () {
	const dispatch = useDispatch()
	const statusPost = useApiStatusEnvAwarePost()
	const {status:packagesStatus,packages} = usePackages()
	const {status:subscriptionsStatus,subscriptions} = useAvailableSubscriptions()
	const {status:merchandiseStatus,merchandise} = useMerchandiseItems()
	const {status:clientsStatus,clients} = useClients()

	const taxPercent = useSelector(
		state => state.settings.app.tax_percent
	)

	const [selectedItemType,setSelectedItemType] = useState('package')
	const [dueDate,setDueDate] = useState(
		new Date()
	)
	const [selectedItemId,setSelectedItemId] = useState(0)
	const [qty,setQty] = useState('')
	const [paymentAmount,setPaymentAmount] = useState('')

	const [selectedClient,setSelectedClient] = useState(null)

	const [clientHasCardOnFile,setClientHasCardOnFile] = useState(false)
	const [loadingBillingInfo,setLoadingBillingInfo] = useState(false)
	useEffect(()=>{
		if (!selectedClient) return 

		setLoadingBillingInfo(true)
		envAwarePost(
			'api/billing/',
			{
				action:'getClientBillingInfo',
				client_id:selectedClient.value
			}
		).then(res=>{
			console.log(res.data.payment_method)
			setClientHasCardOnFile(res.data.payment_method.payment_method_exists)
			setLoadingBillingInfo(false)
		})
		
		
	},[selectedClient])

	const [sessionRate, setSessionRate] = useState("")
	const {acceptedCurrencies} = useCurrencySettings()

	const { acceptedCurrency: defaultAcceptedCurrency } = useCurrencySettings()
	//currency data for sessions
	const [sessionPresentmentCurrencyId,setSessionPresentmentCurrencyId] = useState(1)
	// load sessions and session rate
	useEffect( () => {
		envAwarePost('/api/trainer-gym/sessions/get/', {}).then((res) => {
			const {
				session_rate_presentment_currency_id,
				session_rate
			} = res.data
			setSessionRate(session_rate)
			setSessionPresentmentCurrencyId(session_rate_presentment_currency_id)
		})
	}, [])

	const {default_subscription_billing_anchor:defaultDay} = useSelector(
		state=>state.settings.app
	)
	const [cycleAnchor,setCycleAnchor] = useState(defaultDay)
	const [prorationBehavior,setProrationBehavior] = useState('none')

	const optionsMap = {
		package:{
			text:'Packages',
			component:(
				<Packages
					status={packagesStatus}
					packages={packages}
					onSelect={setSelectedItemId}
					value={selectedItemId}
				/>
			)
		},
		subscription:{
			text:'Subscriptions',
			component:(
				<Subscriptions
					status={subscriptionsStatus}
					subscriptions={subscriptions}
					onSelect={setSelectedItemId}
					value={selectedItemId}
					cycleAnchor={cycleAnchor}
					setCycleAnchor={setCycleAnchor}
					prorationBehavior={prorationBehavior}
					setProrationBehavior={setProrationBehavior}
				/>
			)
		},
		merchandise:{
			text:'Merchandise',
			component:(
				<Merchandise
					status={merchandiseStatus}
					merchandise={merchandise}
					onSelect={setSelectedItemId}
					value={selectedItemId}
				/>
			)
		},
		session:{
			text:'Sessions',
			//sessions don't need a component
			component:null
		},
		custom_payment:{
			text:'Custom Payment',
			component:(
				<CustomPayment
					value={paymentAmount}
					onChange={setPaymentAmount}
				/>
			)
		},
	}

	const requiresQty = ()=>{
		return ['package','session','merchandise'].includes(selectedItemType)
	}

	const requiresItem = ()=>{
		return ['package','subscription','merchandise'].includes(selectedItemType)
	}

	const chargeAmount = ()=>{
		const packageTotal = ()=>{
			if (!selectedItemId) return 0

			const pkg = packages.find(
				({package_id}) => parseInt(package_id) === parseInt(selectedItemId)
			)


			return parseFloat(pkg.package_price)*qty
		}

		const sessionTotal = ()=>{
			return sessionRate*qty
		}

		const merchandiseTotal = ()=>{
			if (!selectedItemId) return 0
			const item = merchandise.find(
				({id}) => parseInt(id) === parseInt(selectedItemId)
			)
			return item.unit_amount/100*qty
		}

		const customTotal = ()=>{
			return paymentAmount
		}

		const subscriptionTotal = ()=>{
			if (!selectedItemId) return 0
			const subscription = subscriptions.find(
				({id})=>parseInt(id)===parseInt(selectedItemId)
			)
			return subscription.price.unit_amount/100
		}
		switch (selectedItemType) {
			case "package": return packageTotal()
			case "session": return sessionTotal()
			case "merchandise": return merchandiseTotal()
			case "subscription": return subscriptionTotal()
			case "custom_payment": return customTotal()
			default: return 0
		}
	}

	const chargeText = ()=>{
		let amount = chargeAmount()*(1+taxPercent/100)

		if (!amount) return 'N/A'

		amount = amount.toFixed(2)

		const packageText = ()=>{
			if (!selectedItemId) return ''

			const pkg = packages.find(
				({package_id}) => parseInt(package_id) === parseInt(selectedItemId)
			)
			return <LocaleCurrency 
				ISO={pkg.currency.ISO} 
				amount={amount}
			/>
		}

		const sessionText = ()=>{
			const currency = acceptedCurrencies.find(
				({id}) => parseInt(id) === parseInt(sessionPresentmentCurrencyId)
			)
			return <LocaleCurrency 
				ISO={currency.ISO} 
				amount={amount}
			/>
		}

		const merchandiseText = ()=>{
			if (!selectedItemId) return 0
			const item = merchandise.find(
				({id}) => parseInt(id) === parseInt(selectedItemId)
			)
			return <LocaleCurrency 
				ISO={item.currency.ISO} 
				amount={amount}
			/>
		}

		const subscriptionText = ()=>{
			if (!selectedItemId) return ''
			const subscription = subscriptions.find(
				({id})=>parseInt(id)===parseInt(selectedItemId)
			)
			return <LocaleCurrency 
				ISO={subscription.price.currency} 
				amount={amount}
			/>
		}

		const customText = ()=>{
			return <LocaleCurrency 
				ISO={defaultAcceptedCurrency.ISO} 
				amount={amount}
			/>
		}

		switch (selectedItemType) {
			case "package": return packageText()
			case "session": return sessionText()
			case "merchandise": return merchandiseText()
			case "subscription": return subscriptionText()
			case "custom_payment": return customText()
			default: return ''
		}
	}

	const getValidationErrors = ()=>{
		const errors = []
		const requiresItemTypes = ['package','merchandise','subscription']
		if (requiresItemTypes.includes(selectedItemType)&&!Boolean(selectedItemId)) {
			errors.push('Select an item')
		}

		const requiresQtyTypes = ['package','merchandise','session']
		if(requiresQtyTypes.includes(selectedItemType)&&!Boolean(qty)) {
			errors.push('Specify a quantity')
		}

		if(selectedItemType==='custom_payment'&&!parseFloat(paymentAmount)){
			errors.push('Specify an amount to charge')
		}

		if(!Boolean(selectedClient)){
			errors.push('Select a client')
		}

		return errors
	}

	const isValid = () => getValidationErrors().length === 0

	const [status,setStatus] = useState('idle')

	const forwardToForms = (forms,programs) => {
		//assign the forms to the client then forward to 
		//the modal for them to fill out the newly assigned forms
		envAwarePost('api/customForms/',{
			action:'addFormsToClient',
			form_ids:forms.map(form=>form.form_id),
		}).then(()=>{
			dispatch(setMultiFormsModal({
				clientId:selectedClient.value,
				show:true,
				programs,
				forms
			}))
		})
	}

	//if packages were purchased that had associated programs 
	//forward to the program assignemnt options
	const forwardToProgramPackageAssignment = programs => {
		//get all packages with these programs
		dispatch(updateProgramAssign({
			clientId:selectedClient.value,
			show:true,
			programs,
		}))
	}

	const handleCharge = ()=>{
		setStatus('pending')
		statusPost('api/purchases/',{
			action:'chargeClientCard',
			billing_cycle_anchor_day:cycleAnchor,
			proration_behavior:prorationBehavior,
			client_id:selectedClient.value,
			item_type:selectedItemType,
			item_id:selectedItemId,
			amount:paymentAmount,
			qty,
		},'Charge')
		.then(res=>{
			console.log(res)
			if(res.success === '1'){
				const {purchase_forms,purchase_programs} = res.data
				if(purchase_forms.length>0){
					forwardToForms(purchase_forms,purchase_programs)
				} else if(purchase_programs.length){
					forwardToProgramPackageAssignment(purchase_programs)
				}
				if(selectedItemType==='subscription'){
					dispatch(getActiveSubscriptions())
				}
			}
			setStatus('idle')
			setSelectedItemId(0)
			setSelectedItemType('package')
			setQty('')
			setPaymentAmount('')
			setSelectedClient(null)
		})
	}

	const buttonText = (
		selectedItemType === 'subscription'
		? 'Setup Subscription'
		: 'Charge Card on File'
	)

	return (
		<div className="p-1">
			<strong>
				Select an item type
			</strong>
			<Form.Control
				onChange={e=>{
					setSelectedItemType(e.target.value)
					setSelectedItemId(0)
					setQty('')
					setPaymentAmount('')
				}}
				value={selectedItemType}
				as="select"
				custom
			>
				{Object.entries(optionsMap).map(([k,opt])=>(
					<option key={k} value={k}>
						{opt.text}
					</option>
				))}
			</Form.Control>
			{optionsMap[selectedItemType].component}
			{requiresQty()&&
				<>
					<strong>
						Set Qty
					</strong>
					<Form.Control 
						onChange={e=>{
							setQty(e.target.value)
						}}
						value={qty}
						placeholder="Qty"
					/>
				</>
			}
			<strong>
				Select a client
			</strong>
			<Select 
				onChange={setSelectedClient}
				value={selectedClient}
				options={clients.map(c=>({
					label:c.user_name,
					value:c.user_id_number
				}))}
			/>
			<div className="text-right mt-2">
				<strong>Total:</strong> {chargeText()}
			</div>
			{taxPercent>0&&
				<div className="text-right text-info mb-2">
					<small>
						<i className="fa fa-info-circle mr-1"/>
						{taxPercent}% tax applied
					</small>
				</div>
			}
			<Button 
				onClick={handleCharge}
				disabled={!clientHasCardOnFile||status==='pending' || !isValid()||loadingBillingInfo}
				variant="outline-success" 
				block
			>
				{buttonText} {status==='pending'&&<Spinner animation="border" size="sm"/>}
			</Button>
			{(Boolean(selectedClient)&&!clientHasCardOnFile&&!loadingBillingInfo)&&
				<div className="text-right text-danger">
					This client does not have a card on file. Add one in the <Link to={`/clientEditor?clientId=${selectedClient.value}`}>client profile</Link> billing section.
				</div>
			}
			{(Boolean(selectedClient)&&loadingBillingInfo)&&
				<div className="text-right text-dark">
					Loading client billing data <Spinner animation="border" size="sm"/>
				</div>
			}
			{!isValid()&&
				<div className="text-right text-danger">
					Required: {getValidationErrors().join(', ')}
				</div>
			}
		</div>
	)
}